<template>
  <div class="content">
    <div class="container-fluid">
      <div>
        <div
          class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
        >
          <div>
            <router-link :to="{ path: '/races'}">
              <button
                type="submit"
                class="btn btn-warning text-white active btn-sm px-3 mr-3"
              >Yarışlar</button>
            </router-link>
            <router-link :to="{ path: '/seasons'}">
              <button type="submit" class="btn btn-info btn-sm px-3 mr-3">Sezonlar</button>
            </router-link>

            <router-link :to="{ path: '/members'}">
              <button type="submit" class="btn btn-danger btn-sm px-3 mr-3">Üyeler</button>
            </router-link>
          </div>
          <span></span>
        </div>
        <card>
          <div>
                <table
                  class="table table-hover table-striped table-bordered mb-0 race-inspect-table"
                >
                  <thead class="thead-dark">
                    <th>Yarış Adı</th>
                    <th>Oyuncu Adı</th>
                    <th>Değişikliği Yapan</th>
                    <th>Önceki Veri</th>
                    <th>Veri</th>
                    <th>Tarih</th>
                  </thead>
                  <tbody>
                    <tr v-for="(log,key) in changes" :key="key">
                      <td>{{log.posts.name}}</td>
                      <td>{{log.oldPlayer.name}} {{log.oldPlayer.surname}}</td>
                      <td>{{log.user.name}} {{log.user.surname}}</td>
                      <td>
                        <span v-if="!log.oldPlayer.status">Beklemede</span>
                        <span v-if="log.oldPlayer.status==2">Revize Talep Edildi</span>
                        <span v-if="log.oldPlayer.status==1">Onaylandı</span>
                        </td>
                      <td>
                        <span v-if="!log.newPlayer.status">Beklemede</span>
                        <span v-if="log.newPlayer.status==2">Revize Talep Edildi</span>
                        <span v-if="log.newPlayer.status==1">Onaylandı</span>
                        </td>
                      <td>{{log.created | moment("Do/MM/YYYY HH:mm:ss")}}</td>

                    </tr>
                  </tbody>
                </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";

export default {
  computed:{
    changes:function(){
      const players = [];
          if(this.logs && this.logs.length){
            for(const log of this.logs){
              const oldDatas = JSON.parse(log.old_datas);
              const newDatas = JSON.parse(log.new_datas);


              for(const i in oldDatas){
                players.push({...log, newPlayer:JSON.parse(JSON.stringify(newDatas[i])),oldPlayer: JSON.parse(JSON.stringify(oldDatas[i]))})
              }
            }
          }
      return players
    }
  },
  data: function() {
    return {
      id: this.$route.params.id,
      // post data
      logs: [],
      datas:[]
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    getInitialData: function() {
      this.toggleLoader();
      this.$http.get("/api/race-logs/get/" + this.id).then(
        response => {
          this.logs = response.body;
          console.log(this.logs);
          this.loading = false;
          this.toggleLoader();
        },
        er => {
            console.log(er)
          this.toggleLoader();
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          return;
        }
      );
    },  

  },
  mounted: function() {
    this.$nextTick(function() {
      this.getInitialData();
      
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/RaceModules/Logs.vue